<template>
  <div id="app" class="h-full flex flex-col">
    <router-view />
    <FloatingAIButton v-if="showAIFloatingButton" :has-new-message="hasNewAIMessage" :unread-count="aiUnreadCount" ai-assistant-route="/ai-assistant" @click="trackAIClick" @quick-action="handleQuickAction" />
  </div>
</template>

<script>
import FloatingAIButton from "@/components/FloatingAIButton.vue";

// 不显示 AI 悬浮按钮的路由列表
const HIDE_AI_BUTTON_ROUTES = [
  '/oauth',      // 登录页
  '/oauth2',     // 登录页2
  '/approve',    // 授权页
  '/apply',      // 申请页
  '/chatBox',    // 聊天框
  '/chatBoxEA',  // EA聊天框
  '/assistant',  // AI助手页面
  '/verifyemail',// 邮箱验证
  '/blueprint',  // 蓝图页
  '/success',    // 成功页
  '/wx',         // 微信相关
  '/404',        // 404错误页
  '/401',        // 401错误页
  '/redirect',   // 重定向页
  '/awards'      // 奖项页
];

export default {
  name: "App",
  components: {
    FloatingAIButton,
  },
  data() {
    return {
      showAIFloatingButton: true,
      hasNewAIMessage: false,
      aiUnreadCount: 0,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.checkShowAIFloatingButton(to.path);
      }
    }
  },
  methods: {
    checkShowAIFloatingButton(path) {
      // 检查当前路由是否在隐藏列表中
      this.showAIFloatingButton = !HIDE_AI_BUTTON_ROUTES.some(route => path.startsWith(route));
    },

    trackAIClick() {
      // 发送统计
      console.log("AI助手按钮被点击");
    },

    handleQuickAction(action) {
      console.log("快捷操作:", action);

      switch (action) {
        case "report":
          this.generateAIReport();
          break;
        case "settings":
          this.openAISettings();
          break;
      }
    },

    generateAIReport() {
      this.$message.info("开始生成AI报告...");
      // 调用生成报告的逻辑
    },

    openAISettings() {
      // 打开设置对话框
      this.$router.push("/settings/ai");
    },
  },
};
</script>
